import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <video src='/videos/herovideo.mp4' autoPlay loop muted />
      <h1>創建您專屬的線上通路</h1>
      <p>找尋顧客最第一手的需求</p>
      <div className='hero-btns'>
        <Button
          className='btns'
          buttonStyle='btn--outline'
          buttonSize='btn--large'
          
        >
         現在開始合作
        </Button>
        
        <Button
          className='btns2'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          onClick={console.log('hey')}

        >
          <p>找尋產品 <i className='fas fa-cart-plus' /></p>
        </Button>
      </div>
    </div>
  );
}

export default HeroSection;
